import masks from './masks';

export const headerShareText =
  'A chance de ficar milionário está a um clique de você. Faça como eu e tenha uma Capitalização da Caixa Seguradora, é fácil e rápido.';
export const headerShareGuideName = '_system';
export const headerShareGuideSettings =
  'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=800';
export const homeStaticText = `É proibida a venda de título de capitalização a menores de dezesseis anos. - Art. 3º, I do Código Civil.
  CNPJ: 01.559.296/0001-71. Processo SUSEP 15414.900329/2019-04 Cap Ganhador Pagamento Único - Processo SUSEP 15414.900328/2019-51 Cap
  Ganhador Pagamento Mensal. A aprovação deste título pela SUSEP não implica, por parte da Autarquia, em incentivo ou recomendação,
  representando, exclusivamente, sua adequação às normas em vigor.`;
export const homeBannerTitle = 'Entenda quanto vai custar o seu produto';
export const homeStoringSectionTitle = 'Como prefere guardar o seu dinheiro?';
export const homeMothlyPaymentText = 'Pagamento mensal';
export const homeMonthlyPaymentDescription = (min = 0, max = 0) =>
  `Você escolhe entre R$ ${masks.currency.mask(min)} e R$ ${masks.currency.mask(
    max
  )} por mês, paga com cartão de crédito ou débito em conta Caixa durante 72 meses e concorre enquanto estiver pagando.`;
export const homeUniquePaymentText = 'Pagamento único';
export const homeUniquePaymentDescription = (min = 0, max = 0) =>
  `Você escolhe entre R$ ${masks.currency.mask(min)} e R$ ${masks.currency.mask(
    max
  )} e pode pagar com cartão de crédito, débito em conta Caixa ou boleto.`;
export const ibcHomeUniquePaymentDescription = (min = 0, max = 0) =>
  `Você escolhe entre R$ ${masks.currency.mask(min)} e R$ ${masks.currency.mask(
    max
  )}, paga com cartão de crédito ou débito em conta Caixa uma única vez e concorre durante 48 meses.`;
export const homePaymentSectionTitle = 'Quanto você quer pagar?';
export const homeTitleSectionTitle = 'Quantos títulos você quer comprar?';
export const homeValueSelectorFooterText = (difference = 0) =>
  `Valores de R$${difference},00 em R$${difference},00`;
export const registerBannerTitle = 'É hora de preencher seus dados pessoais';
export const registerNewsletterText =
  'Como deseja receber informações do Cap Ganhador?';
export const documentsCongratulationsTitle = 'Parabéns';
export const documentsCongratulationsSubTitle =
  'Você acaba de adquirir o seu Cap Ganhador';
export const documentsProposalNumberLabel = 'Anote o número da sua proposta:';
export const documentsProductLabel = 'Acompanhar seu produto';
export const documentsProductButtonText = 'Serviços ao Cliente';
export const ibcDocumentsProductButtonText =
  'Voltar ao Internet Banking da Caixa';
export const documentsFileSectionTitle =
  'Enviamos um email para você com os seguintes arquivos';
export const documentsFileAccessionLabel = 'Proposta de adesão';
export const documentsFileAccessionDescription =
  'Com ela poderá consulta-la sempre que tiver dúvidas sobre seu produto';
export const documentsFileBilletLabel = 'Boleto bancário';
export const documentsFileBilletDescription =
  'Consulte as regras, condições e cobertura do seu produto';
export const documentsFileConditionsLabel = 'Condições gerais';
export const documentsFileConditionsDescrition =
  'Consulte as regras, condições e cobertura do seu produto';
export const documentsFileButtonText = 'Baixar';
export const documentsCompanyContactSectionTitle =
  'Em caso de dúvida, entre em contato com um dos nossos canais de atendimento:';
export const documentsCompanyContactServicesTitle = `Central de Serviços e
Relacionamento`;
export const documentsCompanyContactServicesContent = '3004- 4000';
export const documentsCompanyContactSACTitle =
  'SAC - Sugestões, dúvidas, reclamações e cancelamentos';
export const documentsCompanyContactSACContent = '0800 702 4280';
export const documentsCompanyContactombudsmanTitle = 'Ouvidoria';
export const documentsCompanyContactombudsmanContent = '0800 702 4240';
export const documentsCompanyContactCASTitle =
  'CAS - Central de Atendimento ao Surdo';
export const documentsCompanyContactCASContent = '0800 702 4260';
export const footerAddress =
  'Edifício Sede: SHN Quadra 01, Conj. A, Bl. E Brasília/DF - CEP: 70.701-050';
export const footerCNPJ = 'Caixa Capitalização - 34.020.354/001-10';
export const footerCopyright = '© Copyright 2020 Caixa Seguradora';
export const footerRightsReserved = 'Todos os direitos reservados.';
export const registerTypePersonTitle = 'Você é uma pessoa:';
export const personalDataTitle = 'Dados pessoais';
export const nameInputPlaceholder = 'Nome completo';
export const sexInputPlaceholder = 'Sexo';
export const cpfInputPlaceholder = 'CPF';
export const birthdatePlaceholder = 'Data de nascimento';
export const maritalStatePlaceholder = 'Estado civil';
export const professionPlaceholder = 'Profissão';
export const individualIncomePlaceholder = 'Faixa de renda individual';
export const familyIncomePlaceholder = 'Faixa de renda familiar';
export const addressDataTitle = 'Endereço';
export const addressDataSubtitle =
  'Insira seu CEP e em seguida o endereço será exibido. Complete o que precisar!';
export const cepPlaceholder = 'CEP';
export const addressPlaceholder = 'Endereço';
export const numberPlaceholder = 'Número';
export const additionPlaceholder = 'Complemento';
export const neighborhoodPlaceholder = 'Bairro';
export const cityPlaceholder = 'Cidade';
export const ufPlaceholder = 'UF';
export const contactDataTitle = 'Contato';
export const mobilePhonePlaceholder = 'Telefone celular';
export const commercialPhonePlaceholder = 'Telefone comercial';
export const residentialPhonePlaceholder = 'Telefone residencial';
export const emailPlaceholder = 'Email';
export const forgotCepText = 'Esqueceu seu cep?';
export const paymentTitle = 'Falta pouco para cuidar do seu futuro';
export const confirmDataTitle = 'Verifique seus dados e finalize sua compra.';
const confirmDataSubtitleOne =
  'A Caixa Seguradora pode solicitar cópias dos seus documentos pessoais no momento de devolução dos valores do seu título.';
const confirmDataSubtitleTwo =
  ' Antes de finalizar a compra do seu produto, verifique se seus dados estão corretos.';
export const confirmDataSubtitle = `${confirmDataSubtitleOne}${confirmDataSubtitleTwo}`;
export const congratulationEmailTitle =
  'Por aqui é só! Após identificarmos o pagamento, o seu Cap Ganhador já estará valendo.';
export const congratulationEmailSubtitle =
  'Para sua segurança, enviamos a proposta para o seu e-mail. Assine de forma digital e fique tranquilo!';
export const noPhoneErrorMessage = 'Informe pelo menos um telefone válido';
export const individualIncomeError =
  'A renda individual não deve ser maior que a familiar';
